import { Dispatch } from 'react-redux';
import { AxiosError } from "axios";
import * as _ from "lodash";
import { AuthActionCreators, IApplicationState } from "../";
import {
    IDonorSurgeon, IBillingReport, IBillingPreparationReport, ICenterBillingReport, ICenterContractSummary, IKidneyAvailOnTimeReport, IKidneyAvailOnTimeReportTotals,
    IPatientOutcomes, ISurgicalDecline, IHistogeneticsOrders, IOrgan, IInvoiceLineItem, IInvoiceLineItemReport, IInvoiceDetailReport, IInvoiceHeaderDescription, IBaseResponse, IInvoiceCreditPaymentsReport, IClcScoresSummary, IClcTargetedPairsSummary, IComparisonConversion, IComparisonConversionTotals,
    IInActiveReasonReport, IInActiveReasonReportTotals, IOrganPickupDelivery, IPreReversalReport, INcsScoresReport, IPreSelectHistory, IPreSelectHistoryDetails, IPreWorkUpTransactionDetails, IFamilyVoucherScreeningTransactionDetails,
    ISwapFailureAnalysis, IVrlTransactionGroup, IVxmAnalysis, IChainEndDeclineRatio, INkrDonorReferralConversionRate, IChainEndOffers, IMissedMatchOffer, IMissedRexm, IOverallPerformance, IAccountsPayable, ICenterFiveStarSurvey, ICenterFiveStarSurveyType,
    IAccountsReceivable, IClcScoresDetails, IDonorShieldDirect, ICenter, IAccountsPayableOpo, IAccountsPayableOpoDetail, IAccountsPayableDetail, ILateRexmCompliance, ILateSerology, IMatchOffer, IDonorExportability, IExportabilityGroup,
    ISerologyFinalXmBloodDraw, ISerologyBloodDraw,
    IHistogeneticsHighResTT, IHistogeneticsFVHighResTT, IHistogeneticsCryoReceived, IHistogeneticsCryoShipped, INcsAudit, IUpcomingSwapCalls, IAntiBodyTransactionDetails, ISerologyTransactionDetails, ILateDonorReviews, ISwapCourier, IDashMonitoringCount,
    ICenterFiveStarWeightedAverageResults, IComparisonVolume, IDashVolume, IDashPerformance, IDashDonorData, ICprScore, ICprScoreAudit, IWaitlistAudit, ICenterBase, ILateFinalXm, IHistogeneticsAboUploads, IDashContacts, IAllCentersGrid,
    ICenterChainEndOffer, IPatientExportability,
    IDashPatientDonors, IDonorUpdate,
    IDashPwlLabBilling, IDashPwlJugBilling, ICenterDetails, IMicrositeRecipient, ICenterListResponse,
    IFiveStartCommentResults,
    ITransplantedPatients, IDonorBM3ValidatorList,
    IOnTimeKidneyPickup,
    ISwapQualityIssueForReport,
    IRelativePerformance
} from "@nkr/models/index";
import { IRemoteDonorRegistrationResponse } from "@nkr/store/index"
import { FileDocumentType } from '@nkr/enums/document-type';
import { IGet } from '../authorization/index';
import { IHardToPlaceDonor } from '@nkr/models/hard-to-place-donor';
import { IColdIschemiaLagTime, ISelectedCenterOrgan } from '@nkr/models/reports';
import { OrganType } from '@nkr/enums/organ-type';

// action types

export const ActionTypes = {
    SET_SWAP_QUALITY_ISSUE_REPORT: "SET_SWAP_QUALITY_ISSUE_REPORT",
    SET_BILLING_REPORT: "SET_BILLING_REPORT",
    SET_BILLING_PREPARATION_REPORT: "SET_BILLING_PREPARATION_REPORT"
}

// state interface

export interface IReportState {
    swapQualityIssueReport: ISwapQualityIssueReport,
    billingReport: IBillingReport[],
    billingPreparationReport: IBillingPreparationReport[]
}

// action interfaces

interface ISwapQualityIssueReport {
    donorSurgeons: IDonorSurgeon[],
    issues: ISwapQualityIssueForReport[]
}

export interface ISwapQualityIssueReportResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapQualityIssueReport
    }
}

export interface IBillingReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IBillingReport[]
    }
}

export interface IBillingPreparationReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IBillingPreparationReport[]
    }
}

export interface ICenterBillingReportResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterBillingReport[]
    }
}

export interface ICenterCLCScoresResponse {
    data: {
        success: boolean,
        message: string,
        results: IClcScoresSummary[]
    }
}

export interface ICenterCLCTargetedPairsResponse {
    data: {
        success: boolean,
        message: string,
        results: IClcTargetedPairsSummary[]
    }
}

export interface ICenterCLCDetailsResponse {
    data: {
        success: boolean,
        message: string,
        results: IClcScoresDetails
    }
}

export interface IContractsSummaryResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterContractSummary[]
    }
}

export interface IDonorBM3ValidatorResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorBM3ValidatorList[]
    }
}
export interface IDonorShieldHistoryReportResponse {
    data: {
        success: boolean,
        message: string,
        organs: IOrgan[]
        centers: ICenter[]
        results: IDonorShieldDirect[]
    }
}

export interface IInActiveReasonReports {
    inActiveReasons: IInActiveReasonReport[],
    inActiveReasonsTotals: IInActiveReasonReportTotals[]
}

export interface IInActiveReasonReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IInActiveReasonReports
    }
}

export interface IInvoiceDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            headerDescription: IInvoiceHeaderDescription,
            invoices: IInvoiceDetailReport[],
            lineItems: IInvoiceLineItem[],
            invoiceLineItemReports: IInvoiceLineItemReport[]
        }
    }
}

export interface IInvoiceCreditPaymentsResponse {
    data: {
        success: boolean,
        message: string,
        results: IInvoiceCreditPaymentsReport[]
    }
}

export interface IKidneyAvailOnTimeReports {
    kidneyAvailOnTime: IKidneyAvailOnTimeReport[],
    kidneyAvailOnTimeTotals: IKidneyAvailOnTimeReportTotals[]
}

export interface IKidneyAvailOnTimeReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IKidneyAvailOnTimeReports
    }
}

export interface IOrganPickupDeliveryReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IOrganPickupDelivery[]
    }
}

export interface IPatientOutcomesReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IPatientOutcomes[]
    }
}

export interface IPreselectReversalReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IPreReversalReport[]
    }
}

export interface IDonorExportabilityReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            report: IDonorExportability[],
            centerList: ICenterBase[]
        }
    }
}

export interface IPatientExportabilityReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            report: IPatientExportability[],
            centerList: ICenterBase[]
        }
    }
}

export interface ISwapFailureAnalysisResponse {
    data: {
        success: boolean,
        message: string,
        results: ISwapFailureAnalysis[]
    }
}

export interface ISurgicalDeclineReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            data: ISurgicalDecline[],
            surgeryDateDecline: {
                centerId: number,
                centerAlias: string,
                declineCount: number,
                offerCount: number,
                declineRate: number,
                rank: number
            }
        }
    }
}

export interface IHistogeneticsOrdersReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IHistogeneticsOrders[]
    }
}

export interface IUpcomingSwapCallsReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            callList: IUpcomingSwapCalls[],
            swapCouriers: ISwapCourier[]
        }
    }
}

export interface IVxmAnalysisResponse {
    data: {
        success: boolean,
        message: string,
        results: IVxmAnalysis[]
    }
}

export interface INcsAuditResponse {
    data: {
        success: boolean,
        message: string,
        results: INcsAudit[]
    }
}

export interface ICprScoreResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            data: ICprScore[],
            reportEndDate: string,
            reportStartDate: string
        }
    }
}

export interface ICprScoreAuditResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportData: ICprScoreAudit[],
            reportStart: string,
            reportEnd: string,
            center: ICenterBase
        }
    }
}

export interface IWaitlistAuditResponse {
    data: {
        success: boolean,
        message: string,
        results: IWaitlistAudit[]
    }
}

export interface IChainEndDeclineRatioResponse {
    data: {
        success: boolean,
        message: string,
        results: IChainEndDeclineRatio[]
    }
}

export interface INkrDonorReferralConversionRateResponse {
    data: {
        success: boolean,
        message: string,
        results: INkrDonorReferralConversionRate[]
    }
}

export interface IChainEndOffersResponse {
    data: {
        success: boolean,
        message: string,
        results: IChainEndOffers[]
    }
}

export interface IMissedMatchOffersResponse {
    data: {
        success: boolean,
        message: string,
        results: IMissedMatchOffer[]
    }
}

export interface IMissedRexmsResponse {
    data: {
        success: boolean,
        message: string,
        results: IMissedRexm[]
    }
}

export interface IOverallPerformanceListResponse {
    data: {
        success: boolean,
        message: string,
        results: IRelativePerformance[]
    }
}

export interface IAccountsPayableReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IAccountsPayable[]
    }
}

export interface IAccountsPayableOpoReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reports: IAccountsPayableOpo[]
            currentSemesterLabel: string,
            lastSemesterLabel: string,
            previousSemesterLabel: string
        }
    }
}

export interface IAccountsReceivableReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IAccountsReceivable[]
    }
}

export interface IApDetailReportResponse {
    data: {
        success: boolean,
        results: IAccountsPayableDetail[]
    }
}

export interface IApOpoDetailReportResponse {
    data: {
        success: boolean,
        results: IAccountsPayableOpoDetail[]
    }
}

export interface INcsScoresReportResponse {
    data: {
        success: boolean,
        message: string,
        results: INcsScoresReport[]
    }
}

export interface IHardToPlaceDonorsResponse {
    data: {
        success: boolean,
        results: IHardToPlaceDonor[]
    }
}

export interface IPreSelectHistoryResponse {
    data: {
        success: boolean,
        message: string,
        results: IPreSelectHistory[]
    }
}

export interface IPreSelectHistoryDetailsResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            list: IPreSelectHistoryDetails[],
            average: number
        }
    }
}

export interface ILateRexmReportResponse {
    data: {
        success: boolean,
        message: string,
        results: ILateRexmCompliance[]
    }
}

export interface ILateSerologiesReportResponse {
    data: {
        success: boolean,
        message: string,
        results: ILateSerology[]
    }
}

export interface ISerologyFinalXmBloodDrawsResponse {
    data: {
        success: boolean,
        message: string,
        results: ISerologyFinalXmBloodDraw[]
    }
}

export interface ISerologyBloodDrawsResponse {
    data: {
        success: boolean,
        message: string,
        results: ISerologyBloodDraw[]
    }
}

export interface IVxmAnalysisDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportData: IMatchOffer[],
            startDate: string,
            endDate: string
        }
    }
}

export interface IOnTimeKidneyPickupDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IOnTimeKidneyPickup[]
    }
}

export interface IColdIschemiaLagTimeReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IColdIschemiaLagTime[]
    }
}

export interface IHistogeneticsDetailReports {
    donorHighResTtResults: IHistogeneticsHighResTT[],
    recipientHighResTtResults: IHistogeneticsHighResTT[],
    fvHighResTtResults: IHistogeneticsFVHighResTT[],
    cryoReceivedResults: IHistogeneticsCryoReceived[],
    cryoShippedResults: IHistogeneticsCryoShipped[],
    aboUploadResults: IHistogeneticsAboUploads[]
}

export interface IHistogeneticsDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IHistogeneticsDetailReports
    }
}

export interface IVrlDetailReports {
    serologyResults: ISerologyTransactionDetails[],
    antibodyResults: IAntiBodyTransactionDetails[],
}

export interface IVrlDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: IVrlDetailReports
    }
}

export interface IQuestDetailReportResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            preWorkupLabResults: IPreWorkUpTransactionDetails[],
            fvScreeningResults: IFamilyVoucherScreeningTransactionDetails[],
        }
    }
}

export interface ILateDonorReviewsResponse {
    data: {
        success: boolean,
        results: ILateDonorReviews[]
    }
}

export interface IFiveStarSurveyResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: ICenterFiveStarSurvey[],
            weightedAverageResults: ICenterFiveStarWeightedAverageResults[]
            commentResults: IFiveStartCommentResults[]
        }
    }
}

export interface IComparisonConversionResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IComparisonConversion[],
            grandTotalResults: IComparisonConversionTotals[],
            previousYear: number,
            currentYear: number,
            donationType: number,
            isAnnualized: boolean
        }
    }
}

export interface IComparisonVolumeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IComparisonVolume[],
            donationType: number
        }
    }
}

export interface IDashVolumeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashVolume[],
            donationType: number
        }
    }
}

export interface IDashPwlJugBillingResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashPwlJugBilling[],
            donationType: number
        }
    }
}

export interface IDashPwlLabBillingResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashPwlLabBilling[],
            donationType: number
        }
    }
}

export interface IDashSummaryVolumeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashVolume[],
            donationType: number
        }
    }
}

export interface IDashSummaryPerformanceResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashPerformance[],
            donationType: number
        }
    }
}

export interface IDashSummaryDonorDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDashDonorData[],
            donationType: number
        }
    }
}

export interface IExpiredDonorRow {
    lastCompletedStep: number | null,
    lastCompletedStepDescription: string,
    count: number,
    percentOfTotal: number
}

export interface IExpiredDonorDataResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IExpiredDonorRow[]
        }
    }
}

export interface IDashPatientDonorsResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: {
                listCount: number,
                listData: IDashPatientDonors[],
                micrositeRecipient: IMicrositeRecipient
            },
            donationType: number
        }
    }
}

export interface IDashDonorUpdateResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            reportResults: IDonorUpdate,
            id: number
        }
    }
}

export interface IDashMonitoringResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            registrations: IDashMonitoringCount[],
            referrals: IDashMonitoringCount[],
            donorConnectRequests: IDashMonitoringCount[]
            donorConnectContactsMade: IDashMonitoringCount[],
            labOrders: IDashMonitoringCount[],
            labResults: IDashMonitoringCount[],
        }
    }
}

export interface ICenterChainEndOffersResponse {
    data: {
        success: boolean,
        message: string,
        results: ICenterChainEndOffer[]
    }
}

export interface ILateFinalXmResponse {
    data: {
        success: boolean,
        message: string,
        results: ILateFinalXm[]
    }
}

export interface IDashContactsResponse {
    data: {
        success: boolean,
        results: {
            reportResults: {
                list: IDashContacts[],
                listCount: number
            }
            donationType: number,
        }
    }
}

export interface IAllCentersGridResponse {
    data: {
        success: boolean,
        results: IAllCentersGrid[]
    }
}

export interface ICenterDetailsResponse {
    data: {
        success: boolean,
        results: ICenterDetails
    }
}

export interface ITransplantedPatientsResponse {
    data: {
        success: boolean,
        results: ITransplantedPatients[]
    }
}



export const ActionCreators = {
    getSwapQualityReport: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityIssueReportResponse> => {
        var options = {
            url: `${__API__}/report/swap-quality-issue?startDate=${startDate}&endDate=${endDate}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ISwapQualityIssueReportResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setSwapQualityReport(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSwapQualityReportForCenter: (centerId: number, startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<ISwapQualityIssueReportResponse> => {
        var options = {
            url: `${__API__}/center/${centerId}/report/swap-quality-issue?startDate=${startDate}&endDate=${endDate}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ISwapQualityIssueReportResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setSwapQualityReport(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setSwapQualityReport: (swapQualityIssueReport: ISwapQualityIssueReport) => {
        return { type: ActionTypes.SET_SWAP_QUALITY_ISSUE_REPORT, swapQualityIssueReport };
    },
    getBillingReport: (start: string, end: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBillingReportResponse> => {
        let url = __API__ + '/billing';

        if (start != null && start != "") {
            url += '?start=' + start;
        }

        if (end != null && end != "") {
            url += '&end=' + end;
        }

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IBillingReportResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setBillingReport(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    setBillingReport: (items: IBillingReport[]) => {
        return {
            type: ActionTypes.SET_BILLING_REPORT,
            items
        };
    },
    getBillingPreparationReport: (start: string, updateFees: boolean, organType: OrganType | null) => (dispatch: Dispatch<IApplicationState>): Promise<IBillingPreparationReportResponse> => {
        let url = __API__ + '/report/billing-preparation';

        if (start == null || start == "") {
            var today = new Date();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            start = yyyy + '-' + mm + '-01';
        }

        url += '/' + start;

        const params: string[] = [];
        if (updateFees) params.push('updateFees=1');
        if (organType != null) params.push(`organType=${organType}`);
        if (params.length > 0) url += '?' + params.join('&');

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IBillingPreparationReportResponse) => {
                if (response.data.success)
                    dispatch(ActionCreators.setBillingPreparationReport(response.data.results));

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    setBillingPreparationReport: (items: IBillingPreparationReport[]) => {
        return {
            type: ActionTypes.SET_BILLING_PREPARATION_REPORT,
            items
        };
    },

    getCenterBillingReport: (startDate: string, endDate: string, filterGroup: number, organType: OrganType | null) => (dispatch: Dispatch<IApplicationState>): Promise<ICenterBillingReportResponse> => {
        let url = __API__ + '/report/center-billing';

        let options = {
            url,
            data: {
                startDate,
                endDate,
                filterGroup,
                organType
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: ICenterBillingReportResponse) => {

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getBM3Validator: (donorAlias: string) => (dispatch: Dispatch<IApplicationState>): Promise<IDonorBM3ValidatorResponse> => {
        let url = __API__ + '/admin/matching/matching-validation?donorAlias=' + donorAlias;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IDonorBM3ValidatorResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getCenterContracts: (centerId: string) => (dispatch: Dispatch<IApplicationState>): Promise<IContractsSummaryResponse> => {
        let url = __API__ + '/report/contracts?centerId=' + centerId;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IContractsSummaryResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getCenterContractsExport: (searchValue: string, centerType: string, centerId: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options: IGet = {
            url: __API__ + `/report/contracts-exports?searchValue=${searchValue}&centerType=${centerType}&centerId=${centerId}`,
            responseType: 'blob'
        };
        return dispatch(AuthActionCreators.apiGet(options));
    },

    getCenterCLCScoresReport: () => (dispatch: Dispatch<IApplicationState>): Promise<ICenterCLCScoresResponse> => {
        let url = __API__ + '/report/clc-scores';

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICenterCLCScoresResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                alert(error);
                throw error;
            });
    },

    getCenterCLCScoresDetails: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<ICenterCLCDetailsResponse> => {
        let url = `${__API__}/report/clc-scores-details?centerId=${centerId}`

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICenterCLCDetailsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                alert(error);
                throw error;
            });
    },

    getCenterCLCTargetedPairsReport: () => (dispatch: Dispatch<IApplicationState>): Promise<ICenterCLCTargetedPairsResponse> => {
        let url = __API__ + '/report/clc-targeted-pairs';

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ICenterCLCTargetedPairsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                alert(error);
                throw error;
            });
    },

    updateCenterMonthlyFee: (startDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/report/billing-preparation/load-monthly-fee/" + startDate,
            data: {}
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    updateCenterNkrFee: (centerId: number, newNkrFee: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options = {
            url: __API__ + "/report/billing-preparation/center/" + centerId + "/rmcr-fee?" + "newNkrFee=" + newNkrFee,
            data: {}
        }

        return dispatch(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },
    getInvoiceDetailReport: (startDate: string, endDate: string, showAbbrv: boolean, organType: OrganType) => (dispatch: Dispatch<IApplicationState>): Promise<IInvoiceDetailReportResponse> => {
        let options = {
            url: `${__API__}/report/invoice-detail?startDate=${startDate}&endDate=${endDate}&showAbbrv=${showAbbrv}&organType=${organType}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IInvoiceDetailReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getInvoiceLineItemsExport: (startDate: string, endDate: string, organType: OrganType) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/report/export-invoice-line-items?startDate=${startDate}&endDate=${endDate}&organType=${organType}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getInvoiceCreditPaymentsReport: (centerId: number, startDate: string, endDate: string, organType: OrganType) => (dispatch: Dispatch<IApplicationState>): Promise<IInvoiceCreditPaymentsResponse> => {
        let options = {
            url: `${__API__}/billing/invoice-credit-payments?centerId=${centerId}&startDate=${startDate}&endDate=${endDate}&organType=${organType}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IInvoiceCreditPaymentsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSwapFailureAnalysis: (minimumTxp: number, failureCutoff: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ISwapFailureAnalysisResponse> => {
        let options = {
            url: `${__API__}/report/swap-failure-analysis?minimumTxp=${minimumTxp}&failureCutoff=${failureCutoff}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getVxmAnalysis: (minimumVxmCount: number, minimumSuccessRate: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IVxmAnalysisResponse> => {
        let minSuccessRate = minimumSuccessRate / 100.0;

        let options = {
            url: `${__API__}/report/vxm-analysis?minimumVxm=${minimumVxmCount}&minimumSuccessRate=${minSuccessRate}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getNcsAudit: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<INcsAuditResponse> => {
        let options = {
            url: `${__API__}/report/ncs-audit?centerId=${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getCprScores: (month: number, year: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICprScoreResponse> => {
        let options = {
            url: `${__API__}/report/cpr-report?month=${month}&year=${year}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getCprScoreAudit: (centerId: number, startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ICprScoreAuditResponse> => {
        let options = {
            url: `${__API__}/report/cpr-audit-report?centerId=${centerId}&startDate=${startDate}&endDate=${endDate}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getWaitlistAudit: (centerId: number, startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IWaitlistAuditResponse> => {
        let options = {
            url: `${__API__}/report/waitlist-audit-report?centerId=${centerId}&startDate=${startDate}&endDate=${endDate}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getChainEndDeclineRatio: (minimumChainStarts: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IChainEndDeclineRatioResponse> => {
        let options = {
            url: `${__API__}/report/chain-end-decline-ratio?minimumChainStarts=${minimumChainStarts}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getNkrDonorReferralConversionRate: (referralYear: number, minimumReferrals: number, conversionRateCutoff: number) => async (dispatch: Dispatch<IApplicationState>): Promise<INkrDonorReferralConversionRateResponse> => {
        let options = {
            url: `${__API__}/report/nkr-donor-referral-conversion-rate?referralYear=${referralYear}&minimumReferrals=${minimumReferrals}&conversionRateCutoff=${conversionRateCutoff}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getChainEndOffers: () => async (dispatch: Dispatch<IApplicationState>): Promise<IChainEndOffersResponse> => {
        let options = {
            url: `${__API__}/report/chain-end-offers`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMissedMatchOffers: (startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IMissedMatchOffersResponse> => {
        let options = {
            url: `${__API__}/report/missed-match-offers?startDate=${startDate}&endDate=${endDate}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getLateVxm: (centerId: number, year: number, month: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IMissedMatchOffersResponse> => {
        let options = {
            url: `${__API__}/report/late-vxm?centerId=${centerId}&year=${year}&month=${month}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMissedRexms: () => async (dispatch: Dispatch<IApplicationState>): Promise<IMissedRexmsResponse> => {
        let options = {
            url: `${__API__}/report/missed-rexms`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getOverallPerformanceList: (lvPercentile: number, nvPercentile: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IOverallPerformanceListResponse> => {
        let options = {
            url: `${__API__}/report/overall-performance?lvPercentile=${lvPercentile}&nvPercentile=${nvPercentile}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getAccountsPayable: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAccountsPayableReportResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-payable`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getBillingAsOfReport: (report: 'accounts-receivable' | 'accounts-payable', date: string) => async (dispatch: Dispatch<IApplicationState>): Promise<any> => {
        let options: IGet = {
            url: `${__API_BASE_}/admin/billing-report/${report}/as-of/${date}`,
            responseType: 'blob'
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getApDetailsByCenterId: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IApDetailReportResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-payable/${centerId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    payCcbItems: (achConfirmation: string, amountPaid: number, lineItems: IAccountsPayableDetail[]) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-payable`,
            data: {
                achConfirmation,
                amountPaid,
                lineItems
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IBaseResponse) => {

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getAccountsPayableOpo: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAccountsPayableOpoReportResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-payable-opo`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getApOpoDetailsByOpoId: (opoId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IApOpoDetailReportResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-payable-opo/${opoId}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getAccountsReceivable: (organType: OrganType | null) => async (dispatch: Dispatch<IApplicationState>): Promise<IAccountsReceivableReportResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/accounts-receivable${organType !== null ? `?organType=${organType}` : ''}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    sendDelinquentEmail: (selections: ISelectedCenterOrgan[], emailText: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options = {
            url: `${__API_BASE_}/admin/billing-report/send-delinquent-email`,
            data: {
                selections,
                emailText
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getDonorShieldReport: (startDate: string, endDate: string, centerId: number, organType: number) => (dispatch: Dispatch<IApplicationState>): Promise<IDonorShieldHistoryReportResponse> => {
        let url = __API__ + '/report/donor-shield-history?startDate=' + startDate + '&endDate=' + endDate + '&centerId=' + centerId + '&organType=' + organType;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IDonorShieldHistoryReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getInActiveReasonReport: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IInActiveReasonReportResponse> => {
        let url = __API__ + '/report/inactive-reason?startDate=' + startDate + '&endDate=' + endDate;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IInActiveReasonReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getInActiveResults: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + '/report/inactive-reason-export?startDate=' + startDate + '&endDate=' + endDate,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getKidneyAvailableOnTime: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IKidneyAvailOnTimeReportResponse> => {
        let url = __API__ + '/report/kidney-available-on-time?startDate=' + startDate + '&endDate=' + endDate;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IKidneyAvailOnTimeReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getkidneyAvailableOnTimeExport: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + '/report/kidney-available-on-time-export?startDate=' + startDate + '&endDate=' + endDate,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getOrganPickupDeliveryReport: () => (dispatch: Dispatch<IApplicationState>): Promise<IOrganPickupDeliveryReportResponse> => {
        let url = __API__ + '/report/organ_pickup_and_delivery';

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IOrganPickupDeliveryReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getPatientOutcomesReport: () => (dispatch: Dispatch<IApplicationState>): Promise<IPatientOutcomesReportResponse> => {
        let url = __API__ + '/report/patient-outcomes';

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IPatientOutcomesReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getPreselectReversalReport: (centerId: number, startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IPreselectReversalReportResponse> => {
        let url = __API__ + '/report/preselect-reversal-detail?centerId=' + centerId + '&startDate=' + startDate + '&endDate=' + endDate;

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IPreselectReversalReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getPatientExportabilityReport: (centerId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IPatientExportabilityReportResponse> => {
        let options = {
            url: `${__API__}/report/patient-exportability-report?centerId=` + centerId
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IPatientExportabilityReportResponse) => {

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getDonorExportabilityReport: (centerId: number, exportabilityList: IExportabilityGroup) => (dispatch: Dispatch<IApplicationState>): Promise<IDonorExportabilityReportResponse> => {
        let url = __API__ + '/report/exportability-report?centerId=' + centerId;

        let options = {
            url,
            data: {
                all: exportabilityList.All,
                chainStarters: exportabilityList.ChainStarters,
                pairedDonors: exportabilityList.PairedDonors
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IDonorExportabilityReportResponse) => {

                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getSurgicalDeclinesReport: (centerId: number, startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<ISurgicalDeclineReportResponse> => {
        let url = __API__ + '/report/surgical-declines?centerId=' + centerId + '&startDate=' + startDate + '&endDate=' + endDate;

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ISurgicalDeclineReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getHistogeneticsOrdersReport: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IHistogeneticsOrdersReportResponse> => {
        let url = __API__ + '/report/histogenetics-orders?startDate=' + startDate + '&endDate=' + endDate;

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IHistogeneticsOrdersReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getUpcomingSwapCallsReport: (courierVendor: number) => (dispatch: Dispatch<IApplicationState>): Promise<IUpcomingSwapCallsReportResponse> => {
        let url = courierVendor != 0 ?
            `${__API__}/logistics/call-schedule?courierVendor=` + courierVendor
            :
            `${__API__}/logistics/call-schedule?courierVendor=0`


        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IUpcomingSwapCallsReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getNcsScoresReport: () => async (dispatch: Dispatch<IApplicationState>): Promise<INcsScoresReportResponse> => {
        let url = __API__ + '/report/ncs-report-details';

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getPreselectHistoryReport: (reportDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IPreSelectHistoryResponse> => {
        let url = __API__ + '/report/preselect-history?reportDate=' + reportDate;

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IPreSelectHistoryResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getPreselectHistoryDetailsReport: (centerId: number, startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IPreSelectHistoryDetailsResponse> => {
        let url = `${__API__}/report/preselect-history-details?centerId=${centerId}&startDate=${startDate}&endDate=${endDate}`;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getLateRexmsReport: (month: number, year: number, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ILateRexmReportResponse> => {
        let url = centerId != null ?
            `${__API__}/report/late-rexms?month=${month}&year=${year}&centerId=${centerId}`
            :
            `${__API__}/report/late-rexms?month=${month}&year=${year}&centerId=`;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getLateSerologiesReport: (centerId: number, startDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ILateSerologiesReportResponse> => {
        let url = centerId != null ? __API__ + '/report/late-serologies?centerId=' + centerId + '&sd=' + startDate : __API__ + '/report/late-serologies?centerId=&sd=' + startDate;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getSerologyFinalXmBloodDraws: (centerId: number, startDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyFinalXmBloodDrawsResponse> => {
        let url = centerId != null ? __API__ + '/report/serology-final-xm-blood-draws?centerId=' + centerId + '&sd=' + startDate : __API__ + '/report/serology-final-xm-blood-draws?centerId=&sd=' + startDate;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getSerologyBloodDraws: (centerId: number, startDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ISerologyBloodDrawsResponse> => {
        let url = centerId != null ? __API__ + '/report/serology-blood-draws?centerId=' + centerId + '&sd=' + startDate : __API__ + '/report/serology-blood-draws?centerId=&sd=' + startDate;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getSerologyBloodDrawResults: (id: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options: IGet = {
            url: __API__ + '/report/serology-blood-draws/' + id + '/results',
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getOnTimeKidneyPickupDetailReport: (startDate: string, endDate: string, centerId: number, csv: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IOnTimeKidneyPickupDetailReportResponse> => {
        // let url = centerId != null ? __API__ + '/report/on-time-kidney-pickup-detail?centerId=' + centerId : __API__ + '/report/on-time-kidney-pickup-detail?centerId=';
        // url = url.concat(csv ? '&csv=' + csv : '');

        let url = `${__API__}/report/on-time-kidney-pickup-detail?startDate=${startDate}&endDate=${endDate}&centerId=${centerId != null ? centerId : ''}&csv=${csv ? csv : ''}`;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getColdIschemiaLagTimes: (startDate: string, endDate: string, centerId: number, csv: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IColdIschemiaLagTimeReportResponse> => {
        let url = `${__API__}/report/cold-ischemia-lag-time?startDate=${startDate}&endDate=${endDate}&centerId=${centerId != null ? centerId : ''}&csv=${csv ? csv : ''}`;

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getVxmAnalysisDetailReport: (centerId: number, csv: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IVxmAnalysisDetailReportResponse> => {
        let url = centerId != null ? __API__ + '/report/vxm-analysis-detail?centerId=' + centerId : __API__ + '/report/vxm-analysis-detail?centerId=';
        url = url.concat(csv ? '&csv=' + csv : '');

        let options = {
            url
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getHistogeneticsReport: (startDate: string, endDate: string) => (dispatch: Dispatch<IApplicationState>): Promise<IHistogeneticsDetailReportResponse> => {
        let url = __API__ + '/report/histogenetics-transactions?startDate=' + startDate + '&endDate=' + endDate;

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IHistogeneticsDetailReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getHistogeneticsExport: (startDate: string, endDate: string, reportId: number) => (dispatch: Dispatch<IApplicationState>) => {
        let options: IGet = {
            url: __API__ + `/report/histogenetics-transactions-export?startDate=${startDate}&endDate=${endDate}&reportId=${reportId}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getVrlReport: (filterBy: number, startDate: string, endDate: string, vrltransactionList: IVrlTransactionGroup) => (dispatch: Dispatch<IApplicationState>): Promise<IVrlDetailReportResponse> => {
        let url = __API__ + '/report/vrl-transactions';

        var options = {
            url,
            data: {
                filterBy,
                startDate,
                endDate,
                vrltransactionList
            }
        };
        return dispatch(AuthActionCreators.apiPost(options))
            .then((response: IVrlDetailReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getVrlExport: (filterBy: number, startDate: string, endDate: string, reportId: number, vrltransactionList: IVrlTransactionGroup) => (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: __API__ + `/report/vrl-transactions-export`,
            data: {
                filterBy,
                startDate,
                endDate,
                reportId,
                vrltransactionList
            },
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiPost(options));
    },

    getQuestReport: (startDate: string, endDate: string, filterDate: number) => (dispatch: Dispatch<IApplicationState>): Promise<IQuestDetailReportResponse> => {
        let url = __API__ + '/report/quest-transactions?startDate=' + startDate + '&endDate=' + endDate + '&filterDate=' + filterDate;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IQuestDetailReportResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    getQuestExport: (startDate: string, endDate: string, filterDate: number, reportId: number) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IGet = {
            url: __API__ + `/report/quest-transactions-export?startDate=${startDate}&endDate=${endDate}&filterDate=${filterDate}&reportId=${reportId}`,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },

    getLateDonorReviews: (centerId: number, year: number, month: number) => (dispatch: Dispatch<IApplicationState>): Promise<ILateDonorReviewsResponse> => {
        let options = {
            url: `${__API__}/report/late-donor-reviews?centerId=${centerId}&year=${year}&month=${month}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: ILateDonorReviewsResponse) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                throw error;
            });
    },
    getFiveStarSurvey: (centerId: number, startDate: string, endDate: string, surveyType: ICenterFiveStarSurveyType) => async (dispatch: Dispatch<IApplicationState>): Promise<IFiveStarSurveyResponse> => {
        let url = __API__ + `/report/five-star-surveys`;

        let options = {
            url,
            data: {
                startDate,
                endDate,
                centerId,
                surveyType
            }
        };

        return dispatch(AuthActionCreators.apiPost(options))
            .then(response => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },
    getPwlLabBillingData: (startDate: string, endDate: string, centerId: number, organType: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashPwlLabBillingResponse> => {
        let options = {
            url: `${__API__}/report/pwl-labbilling/`,
            data: {
                startDate,
                endDate,
                centerId,
                organType
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getContactsData: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashContactsResponse> => {
        let options = {
            url: `${__API__}/report/contacts`,
            data: {
                includeNkr,
                includeDash,
                startDate,
                endDate,
                donationType,
                includeNdd,
                includeDd,
                includeSv,
                includeFv,
                ruleOut,
                emrStatus,
                centerId,
                limitStart,
                limitEnd
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getPwlJugBillingData: (startDate: string, endDate: string, isLatestSearch: boolean, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashPwlJugBillingResponse> => {
        let options = {
            url: `${__API__}/report/pwl-jugbilling/`,
            data: {
                startDate,
                endDate,
                isLatestSearch,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getContactsDataExport: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number, limitStart: number, limitEnd: number) => async (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/report/contacts?csv=true`,
            data: {
                includeNkr,
                includeDash,
                startDate,
                endDate,
                donationType,
                includeNdd,
                includeDd,
                includeSv,
                includeFv,
                ruleOut,
                emrStatus,
                centerId,
                limitStart,
                limitEnd
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    getSummaryVolume: (includeNkr: boolean, includeDash: boolean, donationType: number, centerId: number, doGroupByCenter: boolean, isYearly: boolean, includeUdash: boolean = false, includeMs: boolean = false, isAdmin: boolean = false) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSummaryVolumeResponse> => {
        let options = {
            url: `${__API__}/report/summary-volume/`,
            data: {
                includeNkr,
                includeDash,
                isAdmin,
                isMS: includeMs,
                isUDASH: includeUdash,
                donationType,
                doGroupByCenter,
                isYearly,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getDashVolume: (includeNkr: boolean, includeDash: boolean, donationType: number, centerId: number, doGroupByCenter: boolean, isYearly: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashVolumeResponse> => {
        let options = {
            url: `${__API__}/report/volume/`,
            data: {
                includeNkr,
                includeDash,
                donationType,
                doGroupByCenter,
                isYearly,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getSummaryPerformance: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, centerId: number, doGroupByCenter: boolean, includeUdash: boolean = false, includeMs: boolean = false, isAdmin: boolean = false) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSummaryPerformanceResponse> => {
        let options = {
            url: `${__API__}/report/summary-performance/`,
            data: {
                includeNkr,
                includeDash,
                isAdmin,
                isMS: includeMs,
                isUDASH: includeUdash,
                startDate,
                endDate,
                donationType,
                doGroupByCenter,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getSummaryDonorData: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, centerId: number, doGroupByCenter: boolean, includeUdash: boolean = false, includeMs: boolean = false, isAdmin: boolean = false) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashSummaryDonorDataResponse> => {
        let options = {
            url: `${__API__}/report/summary-donor/`,
            data: {
                includeNkr,
                includeDash,
                isAdmin,
                isMS: includeMs,
                isUDASH: includeUdash,
                startDate,
                endDate,
                donationType,
                doGroupByCenter,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getExpiredData: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, donationType: number, centerId: number, includeUdash: boolean = false, includeMs: boolean = false, isAdmin: boolean = false) => async (dispatch: Dispatch<IApplicationState>): Promise<IExpiredDonorDataResponse> => {
        let options = {
            url: `${__API__}/report/expired-donor/`,
            data: {
                includeNkr,
                includeDash,
                isAdmin,
                isMS: includeMs,
                isUDASH: includeUdash,
                startDate,
                endDate,
                donationType,
                centerId
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getPatientDonorsData: (
        donationType: number, centerId: number, firstName: string, lastName: string, lastInitial: string,
        startDate: string, endDate: string, dob: string, donorType: number, statusType: number[],
        micrositeRecipientId: number, dashWorkflowId: number, onlyComplete: boolean, limitStart: number, limitEnd: number
    ) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashPatientDonorsResponse> => {
        let options = {
            url: `${__API__}/report/patient-donors`,
            data: {
                donationType,
                startDate,
                endDate,
                dob,
                donorType,
                statusType,
                centerId,
                firstName,
                lastName,
                lastInitial,
                micrositeRecipientId,
                dashWorkflowId,
                onlyComplete,
                limitStart,
                limitEnd
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getPatientDonorsExport: (
        donationType: number, centerId: number, firstName: string, lastName: string, lastInitial: string,
        startDate: string, endDate: string, donorType: number, statusType: number[],
        micrositeRecipientId: number, dashWorkflowId: number, onlyComplete: boolean, limitStart: number, limitEnd: number
    ) => async (dispatch: Dispatch<IApplicationState>) => {
        let options = {
            url: `${__API__}/report/patient-donors?csv=true`,
            data: {
                donationType,
                startDate,
                endDate,
                donorType,
                statusType,
                centerId,
                firstName,
                lastName,
                lastInitial,
                micrositeRecipientId,
                dashWorkflowId,
                onlyComplete,
                limitStart,
                limitEnd
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    updateDonorRecipient: (id: number, firstName: string, lastName: string, dob: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashDonorUpdateResponse> => {
        let options = {
            url: `${__API__}/report/donor-update`,
            data: {
                id,
                firstName,
                lastName,
                dob
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    registrationsForRemotePatients: (donationType: number, centerId: number, firstName: string, lastName: string, lastInitial: string, statusType: number[],
        micrositeRecipientId: number, dob: string, onlyComplete: boolean, limitStart: number, limitEnd: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IRemoteDonorRegistrationResponse> => {
            let options = {
                url: `${__API__}/report/registrations-remote-patients`,
                data: {
                    donationType,
                    centerId,
                    firstName,
                    lastName,
                    lastInitial,
                    statusType,
                    micrositeRecipientId,
                    dob,
                    onlyComplete,
                    limitStart,
                    limitEnd
                }
            };
            try {
                const response = await dispatch(AuthActionCreators.apiPost(options));
                return response;
            } catch (error) {
                throw error;
            }
        },

    getComparisonConversion: (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, donationType: number, isMicrosite: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IComparisonConversionResponse> => {
        var options = {
            url: `${__API__}/report/comparison-conversion/`,
            data: {
                donationYear,
                minReferrals,
                includeNkr,
                includeDash,
                centerType,
                donationType,
                isMicrosite
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getComparisonConversionExport: (donationYear: string, minReferrals: string, includeNkr: boolean, includeDash: boolean, centerType: string, donationType: number, isMicrosite: number) => async (dispatch: Dispatch<IApplicationState>) => {
        var options = {
            url: `${__API__}/report/comparison-conversion?csv=true`,
            data: {
                donationYear,
                minReferrals,
                includeNkr,
                includeDash,
                centerType,
                donationType,
                isMicrosite
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getComparisonVolume: (includeNkr: boolean, includeDcn: boolean, includeDash: boolean, donationType: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IComparisonVolumeResponse> => {
        var options = {
            url: `${__API__}/report/comparison-volume/`,
            data: {
                includeNkr,
                includeDcn,
                includeDash,
                donationType
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getComparisonVolumeExport: (includeNkr: boolean, includeDcn: boolean, includeDash: boolean, donationType: number) => async (dispatch: Dispatch<IApplicationState>) => {
        var options = {
            url: `${__API__}/report/comparison-volume?csv=true`,
            data: {
                includeNkr,
                includeDcn,
                includeDash,
                donationType
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },

    getDashMonitoring: (startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IDashMonitoringResponse> => {
        let options = {
            url: `${__API__}/public/command-center/dash-monitoring?startDate=${startDate}&endDate=${endDate}`
        };

        return await dispatch(AuthActionCreators.apiGetPublic(options));
    },

    getCenterChainEndOffers: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterChainEndOffersResponse> => {
        let options = {
            url: `${__API__}/report/center/${centerId}/chain-end-offers`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },

    getLateFinalXm: (centerId: number, startDate: string, endDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<ILateFinalXmResponse> => {
        let options = {
            url: `${__API__}/report/late-final-xm?centerId=${centerId}&startDate=${startDate}&endDate=${endDate}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },

    getAllCentersData: () => async (dispatch: Dispatch<IApplicationState>): Promise<IAllCentersGridResponse> => {
        let options = {
            url: `${__API__}/center/all-centers`
        }

        return await dispatch(AuthActionCreators.apiGet(options))
    },

    getCenterDetails: (id: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterDetailsResponse> => {
        let options = {
            url: `${__API__}/center/${id}/details`
        }

        return await dispatch(AuthActionCreators.apiPost(options))
    },

    getTransplantedPatients: (centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<ITransplantedPatientsResponse> => {
        let url = `${__API__}/report/transplanted-patients?centerId=${centerId}`;

        let options = {
            url
        }

        return await dispatch(AuthActionCreators.apiGet(options));
    },


    getCenterComplianceList: () => async (dispatch: Dispatch<IApplicationState>): Promise<ICenterListResponse> => {
        let options = {
            url: `${__API__}/report/center-compliance`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    downloadComplianceFile: (docType: number, centerId: number): any => (dispatch: Dispatch<IApplicationState>) => {
        let location = '';

        switch (docType) {
            case FileDocumentType.RecipientCenterAgreement:
                location = `recipient-center-agreement`
                break;
            case FileDocumentType.CmsGoodStanding:
                location = `cms-standing`
                break;
            case FileDocumentType.DonorCenterAgreement:
                location = `donor-center-agreement`
                break;

            default:
                break;
        }

        var options: IGet = {
            url: __API__ + `/report/center-compliance/${centerId}/` + location,
            responseType: 'blob'
        };

        return dispatch(AuthActionCreators.apiGet(options));
    },
    getHardToPlaceDonors: (isAdmin: boolean, centerId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IHardToPlaceDonorsResponse> => {
        let options = {
            url: isAdmin ? `${__API__}/admin/ncs/donor-acceptance-bonus?centerId=${centerId}` : `${__API__}/ncs/${centerId}/donor-acceptance-bonus`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    }
}

// reducer interfaces

interface ISetSwapQualityIssueReport {
    type: string,
    swapQualityIssueReport: ISwapQualityIssueReport
}

interface ISetBillingReport {
    type: string,
    items: IBillingReport[]
}

interface ISetBillingPreparationReport {
    type: string,
    items: IBillingPreparationReport[]
}

// reducer functions

const setSwapQualityIssueReport = (state: IReportState, action: ISetSwapQualityIssueReport) => {
    state.swapQualityIssueReport = action.swapQualityIssueReport;
    return state;
}

const setBillingReport = (state: IReportState, action: ISetBillingReport) => {
    state.billingReport = action.items;
    return state;
}

const setBillingPreparationReport = (state: IReportState, action: ISetBillingPreparationReport) => {
    state.billingPreparationReport = action.items;
    return state;
}

// reducer creation

var initialState: IReportState = {
    swapQualityIssueReport: {
        donorSurgeons: [],
        issues: []
    },
    billingReport: [],
    billingPreparationReport: []
}

const createReducer = (initialState: IReportState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_SWAP_QUALITY_ISSUE_REPORT]: setSwapQualityIssueReport,
    [ActionTypes.SET_BILLING_REPORT]: setBillingReport,
    [ActionTypes.SET_BILLING_PREPARATION_REPORT]: setBillingPreparationReport,
}

export const Reducer = createReducer(initialState, handlers);
